import React from 'react';
import { format } from 'date-fns';

const DatePicker = ({ selectedDate, onDateChange, id = 'date-picker' }) => {
  return (
    <input
      id={id}
      type="date"
      value={selectedDate ? format(new Date(selectedDate), 'yyyy-MM-dd') : ''}
      onChange={(e) => onDateChange(e.target.value)}
      className="w-full min-h-touch rounded-lg border border-border bg-input px-3 py-2.5 text-text focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20"
      max={format(new Date(), 'yyyy-MM-dd')}
    />
  );
};

export default DatePicker;
